module.exports = __webpack_public_path__ + "img/ergo-essential5.0b8fc3f4.png";